import(/* webpackMode: "eager" */ "/root/enhanci-frontend/components/PlatformLanding/PlatformLanding.tsx")